<template>
  <form @submit.prevent="">
    <ZDialog :show="isVisible" :modal-size="modalSize" :dStyle="'z-index: 1070'" :bdStyle="'z-index: 1065'">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ reportTitle }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" @click="close" class="custom-close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <object width="100%" :height="height" :data="previewContent" :type="mimeType"></object>
      </template>
      <template #footer>
        <button type="button" class="btn btn-default" @click="close()">Close</button>
      </template>
    </ZDialog>
  </form>
</template>
<script>
import { mapState } from 'pinia'
import { authStore } from '@/stores/auth'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import axios from 'axios'
export default {
  name: 'inspection-report',
  components: {
    ZDialog
  },
  props: {
    modelValue: Object,
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalSize: 'modal-xl',
      isLoading: false,
      previewContent: null,
      mimeType: 'application/pdf',
      height: '100%'
    }
  },
  computed: {
    ...mapState(authStore, ['token']),
    isVisible() {
      console.log('modelValue', {
        model: this.modelValue,
        inspection: this.inspection
      })
      this.init()
      return this.modelValue !== null
    },
    reportTitle: {
      get() {
        let _title = ''
        if (this.title !== '') {
          if (this.modelValue !== undefined && this.modelValue !== null) {
            if (this.modelValue.reportName === 'Identified') {
              _title = 'Identified ADAS Report'
            } else if (this.modelValue.reportName === 'Invoice') {
              _title = 'ADAS MAP Invoice'
            } else {
              _title = 'ADAS Inspection Report '
            }
          } else {
            _title = 'ADAS Inspection Report '
          }
          _title += `(for ${this.title})`
        }
        return _title
      }
    },
    reportName() {
      let _reportName = null
      if (this.modelValue) {
        _reportName = this.modelValue.reportName
      }
      return _reportName
    },
    adasInspection() {
      let _id = null
      if (this.modelValue) {
        _id = this.modelValue.adasInspection
      }
      return _id
    }
  },
  methods: {
    init() {
      this.height = '650px'
      this.previewContent = null
      console.log('Initializing Inspection Report', {
        reportName: this.reportName,
        adasInspection: this.adasInspection
      })
      this.fetchReport()
    },
    close() {
      this.$emit('closing')
    },
    base64ToBlob(base64) {
      const binaryString = atob(base64)
      const arrayBuffer = new ArrayBuffer(binaryString.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i)
      }
      return new Blob([uint8Array], { type: this.mimeType })
    },
    processReport(response) {
      this.isLoading = false
      console.log('Response', response)
      if (response.data) {
        if (response.data.pdf) {
          const blob = this.base64ToBlob(response.data.pdf)
          this.previewContent = URL.createObjectURL(blob)
        }
      }
    },
    fetchReport() {
      this.isLoading = true
      let base = window.config ? window.config.adasReportServiceUrl : ''
      let url = ''
      if (base !== '') {
        // reportName is resolved by ADAS Map (report-version.js) from the firm's reportType.
        switch (this.reportName) {
          case 'Inspection':
            url = `${base}/report/inspection?id=${this.adasInspection}&asBase64=true`
            break
          case 'Inspection2':
            url = `${base}/report/inspection2?id=${this.adasInspection}&asBase64=true`
            break
          case 'InspectionLegacy':
            url = `${base}/report/inspectionLegacy?id=${this.adasInspection}&asBase64=true`
            break
          case 'Inspection3':
            url = `${base}/report/inspection2?id=${this.adasInspection}&asBase64=true`
            break
          case 'Identified':
            url = `${base}/report/identified?id=${this.adasInspection}&asBase64=true`
            break
          case 'Invoice':
            url = `${base}/report/proInvoice?id=${this.adasInspection}&asBase64=true`
            break
        }
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        axios.interceptors.request.use(
          (config) => {
            config.headers['Authorization'] = 'Bearer ' + this.token
            return config
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        // the request itself
        axios({
          method: 'get',
          url: url,
          cancelToken: source.token
        })
          .then((response) => {
            this.processReport(response)
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('Request canceled', thrown.message)
            } else {
              // handle error
            }
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-form {
  text-align: left;
}
</style>
